module.exports = __webpack_public_path__ + "img/placeholder.5785c175.png";